// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__k3Y-L","menu__list":"menu_menu__list__Mwgxf","menu__link":"menu_menu__link__GBsP3"};